import { Box, Button, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { MRT_TableInstance } from "material-react-table";
import { handleExport } from "../../../util/handle-export";

type AdminTableTopToolbarProps = {
  table: MRT_TableInstance<any>;
  data: any[];
  title: string;
};

export const AdminTableTopToolbar = ({
  table,
  data,
  title
}: AdminTableTopToolbarProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "16px",
        padding: "8px",
        alignItems: "center"
      }}
    >
      <Typography sx={{ fontSize: "18px", color: "#626262", fontWeight: 700 }}>
        {title}
      </Typography>
      <Button
        onClick={() => handleExport(data)}
        startIcon={<FileDownloadIcon />}
        variant="outlined"
      >
        Export Selected
      </Button>
    </Box>
  );
};
